import { KitchenPage } from './kitchen/KitchenPage'
import { NewOrderPage } from './order-builder/NewOrderPage'
import { ListsPage } from './lists/ListsPage'
import { OrdersRedirect } from './lists/OrdersRedirect'
import { PreordersPage } from './preorders/PreordersPage'
import { RestaurantPage } from './restaurant/RestaurantPage'
import { TableMapPage } from './table-map/TableMapPage'

/**
 * `manager-orders` — the POS core.
 *
 * Ported: every page — preorders, lists, kitchen, table-map, new-order,
 * restaurant. What each still owes is in its spec under `docs/pages/`.
 * `orders.tsx` is not ported (owner decision 1); `/orders` redirects to
 * `/lists`, exactly as legacy does.
 */
export const managerOrdersModule = {
  name: 'manager-orders',
  routes: [
    {
      path: '/new-order',
      page: 'new-order',
      guard: { permission: 'new_order' },
      component: NewOrderPage,
    },
    {
      path: '/preorders',
      page: 'preorders',
      guard: { permission: 'preorders' },
      component: PreordersPage,
    },
    {
      // No guard, exactly as legacy mounts it: any signed-in employee may look
      // at the kitchen board. Accepting an order is what needs a permission, and
      // that check lives on the card.
      path: '/kitchen',
      page: 'kitchen',
      component: KitchenPage,
    },
    {
      path: '/restaurant',
      page: 'restaurant',
      guard: { permission: 'restaurant' },
      component: RestaurantPage,
    },
    {
      path: '/table-map',
      page: 'table-map',
      // Legacy gates this on `restaurant`, not on a table-map permission of its
      // own: the floor plan and the order builder are one job.
      guard: { permission: 'restaurant', franchiseModule: 'restaurant.tables' },
      component: TableMapPage,
    },
    {
      path: '/lists',
      page: 'lists',
      guard: { permission: 'lists' },
      component: ListsPage,
    },
    {
      path: '/orders',
      page: 'lists',
      guard: { permission: 'lists' },
      redirectTo: '/lists',
      component: OrdersRedirect,
    },
  ],
} as const

// §9.341 - the component moved to `@agos/ui`; re-exported so this module's own consumers are
// unaffected by where it lives.
export { CancelOrderModal } from '@agos/ui'
export { WaiterHandoverModal } from './handover/WaiterHandoverModal'
export { KitchenPage, ListsPage, NewOrderPage, PreordersPage, RestaurantPage, TableMapPage }
